import {
    LISTING_PRODUCT,
    LISTING_PRODUCT_SUCCESS,
    LISTING_PRODUCT_FAILED,
    ADDING_PRODUCT,
    ADDING_PRODUCT_SUCCESS,
    ADDING_PRODUCT_FAILED,
    DELETING_PRODUCT,
    DELETING_PRODUCT_SUCCESS,
    DELETING_PRODUCT_FAILED,
    UPDATING_PRODUCT,
    UPDATING_PRODUCT_SUCCESS,
    UPDATING_PRODUCT_FAILED,
    INFO_PRODUCT,
    INFO_PRODUCT_SUCCESS,
    INFO_PRODUCT_FAILED,
    RESET_PRODUCT_EDIT_STATE,
    RESET_PRODUCT_ADD_STATE,
    RESET_PRODUCT_INFO_STATE
} from "./actionTypes"


const INIT_STATE = {
    items: [],
    total: 0,
    item: null,
    isListing: false,
    isAdding: false,
    isDeleting: false,
    isUpdating: false,
    loadingInfo: false,
    listingErrorMessage: null,
    addingErrorMessage: null,
    deletingErrorMessage: null,
    updatingErrorMessage: null,
    infoErrorMessage: null,
    listingSuccessMessage: null,
    addingSuccessMessage: null,
    deletingSuccessMessage: null,
    updatingSuccessMessage: null,
    infoSuccessMessage: null,
}

const Product = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LISTING_PRODUCT:
            return {
                ...state,
                items: [],
                total: 0,
                isListing: true,
                listingErrorMessage: null,
                listingSuccessMessage: null
            }
        case LISTING_PRODUCT_SUCCESS:
            const { items, total, message } = action.payload
            return {
                ...state,
                items: items,
                total: total,
                isListing: false,
                listingErrorMessage: null,
                listingSuccessMessage: message
            }
        case LISTING_PRODUCT_FAILED:
            return {
                ...state,
                items: [],
                total: 0,
                isListing: false,
                listingErrorMessage: action.payload,
                listingSuccessMessage: null
            }
        case ADDING_PRODUCT:
            return {
                ...state,
                isAdding: true,
                addingErrorMessage: null,
                addingSuccessMessage: null
            }
        case ADDING_PRODUCT_SUCCESS:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: null,
                addingSuccessMessage: action.payload
            }
        case ADDING_PRODUCT_FAILED:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: action.payload,
                addingSuccessMessage: null
            }
        case DELETING_PRODUCT:
            return {
                ...state,
                isDeleting: true,
                deletingErrorMessage: null,
                deletingSuccessMessage: null
            }
        case DELETING_PRODUCT_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                deletingErrorMessage: null,
                deletingSuccessMessage: action.payload
            }
        case DELETING_PRODUCT_FAILED:
            return {
                ...state,
                isDeleting: false,
                deletingErrorMessage: action.payload,
                deletingSuccessMessage: null
            }
        case UPDATING_PRODUCT:
            return {
                ...state,
                isUpdating: true,
                updatingErrorMessage: null,
                updatingSuccessMessage: null
            }
        case UPDATING_PRODUCT_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: null,
                updatingSuccessMessage: action.payload
            }
        case UPDATING_PRODUCT_FAILED:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: action.payload,
                updatingSuccessMessage: null
            }
        
        case INFO_PRODUCT:
            return {
                ...state,
                loadingInfo: true,
                item: null,
                infoErrorMessage: null,
                infoSuccessMessage: null
            }
        case INFO_PRODUCT_SUCCESS:
            return {
                ...state,
                loadingInfo: false,
                infoErrorMessage: null,
                item: action.payload,
                infoSuccessMessage: 'Product details fetched successfully.'
            }
        case INFO_PRODUCT_FAILED:
            return {
                ...state,
                loadingInfo: false,
                item: null,
                infoErrorMessage: action.payload,
                infoSuccessMessage: null
            }
        case RESET_PRODUCT_EDIT_STATE:
            return {
                ...state,
                isUpdating: false,
                updatingErrorMessage: null,
                updatingSuccessMessage: null
            }
        case RESET_PRODUCT_ADD_STATE:
            return {
                ...state,
                isAdding: false,
                addingErrorMessage: null,
                addingSuccessMessage: null
            }
        case RESET_PRODUCT_INFO_STATE:
            return {
                ...state,
                loadingInfo: false,
                infoErrorMessage: null,
                infoSuccessMessage: null
            }
        default:
            return state
    }
}

export default Product